export const NotificationApiPath = {
  LIST_NOTIFICATIONS: '/api/sites/{site_id}/notifications', // GET List Notifications
  GET_UNREAD_COUNT: '/api/sites/{site_id}/notifications/unread-count', // GET Get Unread Count
  MARK_AS_READ: '/api/sites/{site_id}/notifications/{notification_id}/read', // PUT Mark As Read
  MARK_ALL_AS_READ: '/api/sites/{site_id}/notifications/read-all' // PUT Mark All As Read
}

export type NotificationApiPath = (typeof NotificationApiPath)[keyof typeof NotificationApiPath]

export interface ListNotificationsVars {
  site_id: number
  unread_only?: boolean
  limit?: number
}

export interface GetUnreadCountVars {
  site_id: number
}

export interface MarkAsReadVars {
  site_id: number
  notification_id: number
}

export interface MarkAllAsReadVars {
  site_id: number
}

import { AppNotification } from '@/common/model/appNotification'

export type ListNotificationsResponse = AppNotification[]

export interface GetUnreadCountResponse {
  unread_count: number
}

export interface MarkAsReadResponse {
  ok: boolean
}

export interface MarkAllAsReadResponse {
  ok: boolean
}
